import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Experience from "@/components/Experience";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

export default function Home() {
    return (
        <div
            id="top"
            data-testid="home-page"
            className="bg-cream text-ink font-sans antialiased overflow-x-clip"
        >
            <Navbar />
            <main>
                <Hero />
                <About />
                <Services />
                <Experience />
                <Gallery />
                <Reviews />
                <Faq />
                <Contact />
            </main>
            <Footer />
            <CookieBanner />
        </div>
    );
}
